import { useMutation, useQuery } from 'react-query';

import { getFeatures, viewFeatureReminder } from './service';
import { GetActiveFeaturesDto } from './types';
import { ErrorResponse } from '../common/utils/error';

export function useGetFeatures() {
  return useQuery<GetActiveFeaturesDto, ErrorResponse>('features', () =>
    getFeatures()
  );
}

export function useViewFeatureReminderCommand() {
  return useMutation<
    { success: boolean },
    ErrorResponse,
    { featureId: string; screenName: string }
  >(viewFeatureReminder);
}
